<div class="page-title__bar">
  <h2 class="title">Downloads</h2>
  <div class="user-actions">
    <button class="btn add-user-btn" (click)="openUploadModal()">
      Add APK<i class="fa fa-plus ml-2" aria-hidden="true"></i>
    </button>
  </div>
</div>

<br />

<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="downloads" role="tabpanel" aria-labelledby="downloads-tab">
    <div class="right__panel calendar-data__wrapper">
      <div class="table-data__wrapper table-responsive calendar-data--table">
        <table class="table table-data">
          <thead>
            <tr>
              <th *ngFor="let header of tableHeaders" scope="col">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let build of androidBuilds" class="hover-row">
              <td>{{ build.fileName }}</td>
              <td>{{ build.buildDate || 'N/A' }}</td>
              <td style="max-width: 400px; word-wrap: break-word;">
                <a [href]="build.url" target="_blank" class="url-link">
                  {{ build.url }}
                </a>
              </td>
              <td style="cursor: default">
                <div
                  [ngStyle]="{
                    'align-items': 'center',
                    'justify-content': 'center',
                    display: 'flex',
                    gap: '8px'
                  }"
                >
                  <button
                    class="btn primary-btn"
                    (click)="copyUrl(build)"
                    ngbTooltip="Copy URL"
                    [openDelay]="400"
                    [closeDelay]="400"
                  >
                    <i class="fa fa-copy" style="color: white" aria-hidden="true"></i>
                  </button>
                  <button
                    class="btn primary-btn"
                    (click)="downloadUrl(build)"
                    ngbTooltip="Download APK"
                    [openDelay]="400"
                    [closeDelay]="400"
                  >
                    <img src="/assets/icons/download.svg" />
                  </button>
                  <button
                    class="btn del-btn"
                    (click)="deleteApkFile(build)"
                    ngbTooltip="Delete"
                    [openDelay]="400"
                    [closeDelay]="400"
                  >
                    <img src="/assets/icons/trash.svg" />
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="androidBuilds.length === 0">
              <td [attr.colspan]="tableHeaders.length" class="text-center" style="padding: 40px; color: gray;">
                No Android builds available
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

